import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Text, Box, CenteredContainer } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';

import Expandable from '../expandable/expandable';
import DrawerToggle from '../drawer-toggle/drawer-toggle';
import Calculator from './calculator';
import Results from './results';
import calculations from './calculations';

import reactThrottleRender from '../../lib/throttle-render';

import './compound-interest-calculator.less';

const ThrottledResults = reactThrottleRender(300)(Results);

ThrottledResults.displayName = 'ThrottledResults';

class CompoundInterestCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = calculations();
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(name, value) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState(calculations(this.state, { name, value }));
  }

  render() {
    const { size, summaryHeading, summaryBody } = this.props;
    const { outputs, ready } = this.state;
    const calculator = (
      <Box className="compound-interest-calculator__calculator">
        <Calculator
          data={this.state}
          onChange={this.handleInputChange}
          formName="compound-interest-calculator-lpc"
          size={size}
        />
      </Box>
    );
    const expandingCalculatorSection = (
      <Expandable
        trackingData={{
          formName: 'compound-interest-calculator-filters',
          fieldName: 'filters-drawer',
          fieldValue: 'filters-drawer',
        }}
        render={(toggleExpanded, isExpanded) => (
          <Fragment>
            <Box className="toggle-expanded-after-product">
              <DrawerToggle
                onClick={toggleExpanded}
                isExpanded={isExpanded}
                openText="Hide Filters"
                closedText="View Filters (5)"
                appearance="teal"
              />
            </Box>
            {isExpanded ? calculator : null}
          </Fragment>
        )}
      />
    );

    return (
      <CenteredContainer
        className={classNames([
          'compound-interest-calculator',
          'landing-page-standard__max-widths',
        ])}
      >
        {size === 'sm' ? expandingCalculatorSection : calculator}
        <Box className="compound-interest-calculator__results">
          <ThrottledResults data={outputs} ready={ready} size={size} />
          <Box className={nds('padding-top-3')}>
            <Text size="large" component="h5" bold>
              {summaryHeading}
            </Text>
          </Box>
          <Text>{summaryBody}</Text>
        </Box>
      </CenteredContainer>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompoundInterestCalculator.propTypes = {
  size: PropTypes.string,
  summaryHeading: PropTypes.string,
  summaryBody: PropTypes.string,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompoundInterestCalculator.defaultProps = {
  size: 'sm',
};

export default connect(({ mediaQuery }) => ({ size: mediaQuery }))(
  CompoundInterestCalculator
);
